export default __webpack_public_path__ + "static/media/overview3.778698bc.jpg";